<app-construction-documents-wrapper>
  @if (modalState()) {
    <app-download-file-confirmation-modal
      (proceedDownload)="handleFileDownload($event)"
    />
  }

  @if (
    constructionDocumentsResponse$ | async;
    as constructionDocumentsResponse
  ) {
    @if (constructionDocumentsResponse.isLoading) {
      <div class="loading-spinner">
        <gc-loading-spinner [pixelSize]="64" />
        <gc-text [variant]="'smallHeading'">{{
          'loading' | translate
        }}</gc-text>
      </div>
    }

    @if (constructionDocumentsResponse.hasErrors) {
      @if (checkKnownError(constructionDocumentsResponse.error.error)) {
        <app-error-information
          [iconName]="'smileySad'"
          [iconColor]="'caution'"
          [errorString]="
            'errorMessages.' +
            getKnownErrorString(constructionDocumentsResponse.error.error)
          "
        />
      } @else {
        <app-error-information
          [iconName]="'smileyEyesX'"
          [iconColor]="'critical'"
          [errorString]="'errorMessages.unknownError'"
        />
      }
    }

    @if (
      !constructionDocumentsResponse.isLoading &&
      constructionDocumentsResponse.isSuccess
    ) {
      <div class="top-container">
        @if (sharepointExport && hasAccessByRole) {
          <gc-button
            [size]="isMobileScreen() ? 'full' : 'default'"
            [variant]="'secondary'"
            [icon]="'arrowRight'"
            [iconPosition]="'right'"
            (clicked)="handleOnClickSharepointExportButton()"
          >
            {{ 'sharepointExport.sharepointExport' | translate }}
          </gc-button>
        }

        <div class="info-container">
          @if (breadcrumbs$ | async; as breadcrumbs) {
            <app-breadcrumbs
              [breadcrumbs]="breadcrumbs"
              [compact]="isMobileScreen()"
              (clicked)="handleOnClickBreadcrumb($event)"
            />
          }

          <gc-text
            [textColor]="'secondary'"
            [variant]="isMobileScreen() ? 'information' : 'body'"
          >
            {{ generateSizeString(constructionDocumentsResponse.data) }}
          </gc-text>
        </div>
      </div>

      @if (constructionDocumentsResponse.data.items.length) {
        <app-folder-content-wrapper
          [isMobileScreen]="isMobileScreen()"
          [data]="constructionDocumentsResponse.data"
        />
      } @else {
        <app-error-information
          [iconName]="'folder'"
          [iconColor]="'info'"
          [errorString]="'errorMessages.emptyFolder'"
        />
      }
    }
  }

  @if (noIfs$ | async) {
    <app-error-information
      [iconName]="'circleInfo'"
      [iconColor]="'info'"
      [errorString]="'errorMessages.chooseProjectIfs'"
    />
  }
</app-construction-documents-wrapper>
